import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isConfirmClicked: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        isConfirmClicked: false,
      });
    }
  }

  render() {
    const {
      classes,
      t,
      isOpen,
      title,
      children,
      onClose,
      onConfirm,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="confirm-form-dialog-title"
        className="confirm-dialog"
      >
        <DialogTitle id="confirm-form-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            className="confirm-dialog-close-button"
          >
            {t('Close')}
          </Button>
          <Button
            onClick={() => {
              this.setState({
                isConfirmClicked: true,
              });

              onConfirm();
            }}
            color="primary"
            autoFocus
            disabled={this.state.isConfirmClicked}
            className="confirm-dialog-close-button"
          >
            {t('Confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(ConfirmDialog);
